  export const tabsConfig = [
    // { key: 'personal', label: 'Personal', isEnabled: true },
    { key: 'activities', label: 'Personal', isEnabled: true },
    { key: 'work', label: 'Work', isEnabled: true },
    { key: 'team', label: 'Teams', isEnabled: true },
    { key: 'report', label: 'Reporting', isEnabled: true },
    { key: 'education', label: 'Education', isEnabled: true },
    { key: 'family', label: 'Family', isEnabled: true },
    { key: 'documents', label: 'Documents', isEnabled: true },
    { key: 'workweek', label: 'Work week', isEnabled: true },
    { key: 'offboarding', label: 'Resignation', isEnabled: true },
    // { key: 'timesheets', label: 'Timesheets', isEnabled: false },
    // { key: 'jobs', label: 'Jobs', isEnabled: false },
  ];